import React from 'react';
import PropTypes from 'prop-types';

const AISkills = ({ type }) => {
  if (type === 'freelancer') {
    return (
      <>
        <li>
          <a href="/jobs/ai-engineers">AI engineer jobs</a>
        </li>
        <li>
          <a href="/jobs/ai-trainers">AI trainer jobs</a>
        </li>
        <li>
          <a href="/jobs/ai-evaluators">AI evaluator jobs</a>
        </li>
        <li>
          <a href="/jobs/app-developers">App developer jobs</a>
        </li>
        <li>
          <a href="/jobs/developers">Developer jobs</a>
        </li>
        <li>
          <a href="/jobs/front-end-developers">Front-end developer jobs</a>
        </li>
        <li>
          <a href="/jobs/full-stack-developers">Full stack developer jobs</a>
        </li>
        <li>
          <a href="/jobs/back-end-developers">Back-end developer jobs</a>
        </li>
        <li>
          <a href="/jobs/data-scientists">Data scientists jobs</a>
        </li>
        <li>
          <a href="/jobs/database-developers">Database developer jobs</a>
        </li>
        <li>
          <a href="/jobs/blockchain-developers">Blockchain developer jobs</a>
        </li>
      </>
    );
  }

  return (
    <>
      <li>
        <a href="/find/ai-engineers">AI engineers</a>
      </li>
      <li>
        <a href="/find/ai-trainers">AI trainers</a>
      </li>
      <li>
        <a href="/find/ai-evaluators">AI evaluators</a>
      </li>
      <li>
        <a href="/find/data-scientists">Data scientists</a>
      </li>
      <li>
        <a href="/find/developers/with/python">Python developers</a>
      </li>
      <li>
        <a href="/find/ai-strategy-consultants">AI strategy consultants</a>
      </li>
      <li>
        <a href="/find/ai-ethics-consultants">AI ethics consultants</a>
      </li>
      <li>
        <a href="/find/qa-engineers">QA engineers</a>
      </li>
      <li>
        <a href="/find/audio-transcribers">Audio transcribers</a>
      </li>
      <li>
        <a href="/find/ai-engineers/with/pytorch">PyTorch developers</a>
      </li>
      <li>
        <a href="/find/back-end-developers">Back-end developers</a>
      </li>
      <li>
        <a href="/find/cloud-developers">Cloud developers</a>
      </li>
    </>
  );
};

AISkills.propTypes = {
  type: PropTypes.string.isRequired,
};

export default AISkills;
